import url from 'url';
import Link from 'next/link';
import propTypes from 'prop-types';
import React from 'react';
import * as theme from '../constants/theme';
import getComponent from '../utils/component';

const {GUTTER, TEXT_WHITE, TEXT_WHITE_HOVER} = theme;

const MainMenuItem = ({onClick, title, url: uri}) => {
	const isLocal = uri && uri.includes(url.parse(API).host);
	const path = isLocal ? url.parse(uri).pathname : uri;
	const component = getComponent(path);

	return (
		<li>
			{isLocal ? (
				<span onClick={onClick}>
					<Link prefetch href={`/${component}?slug=${path}`} as={path}>
						<a>{title}</a>
					</Link>
				</span>
			) : (
				<a href={path} onClick={onClick}>
					{title}
				</a>
			)}

			<style jsx>
				{`
					li {
						display: inline-block;
						width: 100%;
						padding: calc(${GUTTER} / 2);
						transition: 300ms ease-out all;
						text-transform: uppercase;
						font-size: 1.5rem;
					}

					a {
						display: inline-block;
						padding: 0;
						color: ${TEXT_WHITE};
						font-weight: normal;
					}

					a:hover {
						color: ${TEXT_WHITE_HOVER}
					}
				`}
			</style>
		</li>
	);
};

MainMenuItem.propTypes = {
	title: propTypes.string,
	url: propTypes.string,
	onClick: propTypes.func
};

export default MainMenuItem;



// WEBPACK FOOTER //
// components/main-menu-item.js